import { Button } from 'primereact/button';

import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Ripple } from 'primereact/ripple';
import { Link } from 'react-router-dom';
import { Menubar } from 'primereact/menubar';
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import useUserRole from '../contexts/useUserRole'; // 



export default function Sidebar({ setVisible }) {
    const [sidebar, setSidebar] = useState(window.innerWidth <= 1050);
    const { role, loading } = useUserRole();

    const location = useLocation();

    // Example: Show button only on homepage
    const showButton = location.pathname === '/';

    console.log('19 - sidebar');
    console.log(role);

    const menuItems = [
        {
            label: 'Dashbaord',
            icon: 'pi pi-home',
            url: '/',
            allowedRoles: ['admin', 'superadmin'],
        },
        {
            label: 'Orders',
            icon: 'pi pi-box',
            url: '/orders',
            allowedRoles: ['admin', 'superadmin'],
        },
        {
            label: 'Tickets',
            icon: 'pi pi-ticket',
            url: '/tickets',
            allowedRoles: ['admin', 'superadmin'],
        },
        {
            label: 'Vendors',
            icon: 'pi pi-shop',
            url: '/vendors',
            allowedRoles: ['superadmin'],
        },
        {
            label: 'Products',
            icon: 'pi pi-objects-column',
            url: '/products',
            allowedRoles: ['superadmin'],
        },
        {
            label: 'Riders',
            icon: 'pi pi-truck',
            url: '/riders',
            allowedRoles: ['superadmin'],
        },
        {
            label: 'Banners',
            icon: 'pi pi-image',
            url: '/banners',
            allowedRoles: ['superadmin'],
        },
        {
            label: 'Categories',
            icon: 'pi pi-tags',
            url: '/categories',
            allowedRoles: ['superadmin'],
        },
        {
            label: 'Platform Fee',
            icon: 'pi pi-dollar',
            url: '/platformfee',
            allowedRoles: ['superadmin'],
        },
        {
            label: 'Delivery Types',
            icon: 'pi pi-truck',
            url: '/delivery',
            allowedRoles: ['superadmin'],
        },
        {
            label: 'Promo Codes',
            icon: 'pi pi-percentage',
            url: '/codes',
            allowedRoles: ['superadmin'],
        }
    ];

    const filteredMenu = menuItems.filter(item => item.allowedRoles.includes(role));


    const handleResize = () => {
        setSidebar(window.innerWidth <= 1050);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Close sidebar on ESC key

    // useEffect(() => {
    //     const handleKeyDown = (e) => {
    //         if (e.key === 'Escape') {
    //             setVisible(false);
    //         }
    //     };
    //     window.addEventListener('keydown', handleKeyDown);
    //     return () => window.removeEventListener('keydown', handleKeyDown);
    // }, [setVisible]);

    // useEffect(() => {
    //     if (!sidebar) {
    //         const handleKeyDown = (e) => {
    //             if (e.key === 'Escape') {
    //                 setVisible(false);
    //             }
    //         };
    //         window.addEventListener('keydown', handleKeyDown);
    //         return () => window.removeEventListener('keydown', handleKeyDown);
    //     }
    // }, [sidebar, setVisible]);

    const logoutUser = async () => {
        await signOut(auth);
        console.log('User logged out');
    }

    if (loading) return null; // Or a loading spinner


    return (
        <>        {
            !sidebar ?
                <div
                    className="surface-section border-right-1 surface-border select-none flex-1"
                    style={{
                        width: '250px',
                        height: '100vh',
                        boxSizing: 'border-box',
                        padding: '1rem',
                        overflowY: 'auto',
                    }
                    }
                >
                    <div className="flex align-items-center justify-content-between mb-4">
                        <span className="font-semibold text-2xl text-primary">Knock Deliver</span>
                        {
                            !showButton && <Button size='small' icon='pi pi-bars' onClick={() => setVisible(false)}></Button>
                        }
                    </div>

                    <ul className="list-none p-0 m-0">

                        {menuItems.map(item => (
                            item.allowedRoles.includes(role) && (
                                <li key={item.path}>
                                    <Link to={item.url} className="no-style-link">
                                        <a className="p-ripple flex align-items-center p-3 border-round text-700 hover:surface-100 w-full cursor-pointer">
                                            <i className={`${item.icon} mr-2`}></i>
                                            <span className="font-medium">{item.label}</span>
                                            <Ripple />
                                        </a>
                                    </Link>
                                </li>
                            )
                        ))}

                        {/* <li>
                            <Link to='/' className="no-style-link">
                                <a className="p-ripple flex align-items-center p-3 border-round text-700 hover:surface-100 transition-duration-150 w-full cursor-pointer">
                                    <i className="pi pi-home mr-2"></i>
                                    <span className="font-medium">Dashboard</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li>

                        <li>
                            <Link to={'/orders'} className="no-style-link">
                                <a className="p-ripple flex align-items-center p-3 border-round text-700 hover:surface-100 transition-duration-150 w-full cursor-pointer">
                                    <i className="pi pi-box mr-2"></i>
                                    <span className="font-medium">Orders</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li>

                        <li>
                            <Link to={'/products'} className="no-style-link">
                                <a className="p-ripple flex align-items-center p-3 border-round text-700 hover:surface-100 transition-duration-150 w-full cursor-pointer">
                                    <i className="pi pi-objects-column mr-2"></i>
                                    <span className="font-medium">Products</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li>

                        <li>
                            <Link to={'/vendors'} className="no-style-link">
                                <a className="p-ripple flex align-items-center p-3 border-round text-700 transition-duration-150 hover:surface-100 w-full cursor-pointer">
                                    <i className="pi pi-shop mr-2"></i>
                                    <span className="font-medium">Vendors</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li>

                        <li>
                            <Link to={'delivery'} className="no-style-link">
                                <a className="p-ripple flex align-items-center p-3 border-round text-700 hover:surface-100 w-full cursor-pointer">
                                    <i className="pi pi-truck mr-2"></i>
                                    <span className="font-medium">Riders</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li> */}



                        {/* <li> */}
                        {/* <StyleClass nodeRef={btnRef4} selector="@next" enterFromClassName="hidden" enterActiveClassName="slidedown" leaveToClassName="hidden" leaveActiveClassName="slideup">
                                <div ref={btnRef4} className="p-ripple p-3 flex align-items-center justify-content-between text-600 cursor-pointer">
                                    <span className="font-medium">Home (APP)</span>
                                    <i className="pi pi-chevron-down"></i>
                                    <Ripple />
                                </div>
                            </StyleClass> */}
                        {/* <ul className="list-none p-0 m-0 overflow-hidden"> */}

                        {/*                         
                        <li>
                            <Link to={'/home/banners'} className="no-style-link">
                                <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                    <i className="pi pi-image mr-2"></i>
                                    <span className="font-medium">Banners</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li>
                        <li>
                            <Link to={'/home/categories'} className="no-style-link">
                                <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                    <i className="pi pi-tags mr-2"></i>
                                    <span className="font-medium">Categories</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li>
                        <li>
                            <Link to={'/home/delivery'} className="no-style-link">
                                <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                    <i className="pi pi-dollar mr-2"></i>
                                    <span className="font-medium">Delivery Types</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li>
                        <li>
                            <Link to={'/home/codes'} className="no-style-link">
                                <a className="p-ripple flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors w-full">
                                    <i className="pi pi-percentage mr-2"></i>
                                    <span className="font-medium">Promo Codes</span>
                                    <Ripple />
                                </a>
                            </Link>
                        </li> */}
                        {/* </ul> */}
                        {/* </li> */}
                    </ul>
                    <div className="mt-auto" onClick={logoutUser}>
                        <hr className="mb-3 mx-3 border-top-1 border-none surface-border" />
                        <a className="m-3 flex align-items-center cursor-pointer p-0 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
                            <i className='pi pi-sign-out mr-2'></i>
                            <span className="font-bold">Logout</span>
                        </a>
                    </div>
                </div >

                :
                <div className="card">
                    <h2 style={{ textAlign: 'center', marginBlock: '0.5rem' }}>Knock Deliver</h2>
                    <Menubar model={filteredMenu} />
                    {/* {menuItems.map(item => (
                        item.allowedRoles.includes(role) && (
                            <li key={item.path}>
                                <Link to={item.url} className="no-style-link">
                                    <a className="p-ripple flex align-items-center p-3 border-round text-700 hover:surface-100 w-full cursor-pointer">
                                        <i className={`${item.icon} mr-2`}></i>
                                        <span className="font-medium">{item.label}</span>
                                        <Ripple />
                                    </a>
                                </Link>
                            </li>
                        )
                    ))} */}
                </div>

        }
        </>

    );
}